module.exports = {"data":{"contentfulCategory":{"name":"Product engagement tools","slug":"product-engagement-tools","description":null,"seoPageTitle":null,"subcategory":null,"product":null}},"pathContext":{"slug":"product-engagement-tools"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/category-product-engagement-tools.json
// module id = 1145
// module chunks = 261131818683402